import { z } from 'zod';

import Timestamp from '@/store/modules/models/global/Timestamp';

const PartyStatus = z.object({
    accepted: z.boolean(),
    action_performed_date: Timestamp,
    bounced: Timestamp,
    client_id: z.number(),
    computed_status: z.string(),
    computed_status_date: Timestamp,
    fingerprint: z.string(),
    reminder_date: Timestamp,
    sent: Timestamp,
});

export default PartyStatus;
